export enum TimeConversions {
    SECONDS_PER_MINUTE = 60,
    SECONDS_PER_HOUR = 3600,
    SECONDS_PER_DAY = 86400,
    SECONDS_PER_WEEK = 604800,
    SECONDS_PER_MONTH = 2592000,
    SECONDS_PER_YEAR = 31556926,
    MINUTES_PER_DAY = 1440,
    HOURS_PER_DAY = 24,
    HOURS_PER_WEEK = 168,
    HOURS_PER_MONTH = 730,
    HOURS_PER_YEAR = 8760,
    DAYS_PER_WEEK = 7,
    DAYS_PER_MONTH = 30,
    WEEK_PER_YEAR = 52,
    MONTH_PER_YEAR = 12,
}
